<template>
  <div class="case-chat">
    <div class="case-chat-header" v-if="this.$route.query.meeting_id" style="height: 54px">
      <div class="case-chat-name d-flex-between" v-if="meetingData != undefined">
        <div>{{caseDetailValue.name}}的会诊咨询</div>
        <div style="width: fit-content">会诊时间：{{ meetingData.start_time2 }} - {{ meetingData.end_time2 }}</div>
      </div>
    </div>

    <div class="case-chat-header" v-else>
      <div class="case-chat-name d-flex-between" v-if="caseDetailValue">
        <div v-if="member.member_type == 0">
          <div>{{ caseDetailValue.mentor.real_name }}</div>
          <div>{{ caseDetailValue.mentor.organization }}</div>
        </div>
        <div v-else>
          <div>{{ caseDetailValue.doctor.real_name }}</div>
          <div>{{ caseDetailValue.doctor.organization }}</div>
        </div>
        <div class="case-chat-name d-flex-between" v-if="meetingData">
          <div></div>
          <div style="width: fit-content">会诊时间：{{ meetingData.start_time2 }} - {{ meetingData.end_time2 }}</div>
        </div>
        <div  class="case-chat-toast">{{caseDetailValue.finished_status == 1 ? '该病例已结束全周期辅导咨询' : caseDetailValue.be_full_consult == 1 ? '该病例正在进行全周期辅导咨询' : member.member_type == 1 ? '当前为预咨询，学员发送3次消息或24小时后关闭，关闭后您可延长咨询时长。' : '当前为预咨询，对话将在发送3次消息或24小时后关闭。' }}</div>
        <div class="case-chat-btn" v-if="caseDetailValue.finished_status != 1 && caseDetailValue.be_full_consult != 1 && member.member_type == 1" @click="luckChat">延长会话</div>
        <div class="case-chat-btn" v-if="caseDetailValue.finished_status != 1 && caseDetailValue.be_full_consult != 1 && member.member_type == 0" @click="showCycleDialog = true">解锁全周期咨询</div>
    </div>
    </div>

    <div ref="mianscroll" class="case-chat-cont" @click="msgOptionState = false" @scroll="chatMsgScroll"
         @click.right="chatRightClick">
      <div v-if="isTop" class="msg-line">
        <div class="msg-over">没有更多消息了</div>
      </div>
      <template v-for="(item,index) in chatList">
        <ChatMessage ref="chatMessage" :from-user="member.yunxin_accid" :message="item"
                     :nim="nim"
                     :to-user="caseDetailValue.im_group_id" :avatar="avatarData[item.from]" @rightClick="showMsgOption"/>
      </template>
    </div>

    <div class="case-chat-bottom">
      <div v-if="isReview" class="reback-message">
        <div class="reback-message-line">
          <div style="margin-bottom: 4px">{{ reviewMsgOptionInfo.fromNick }}</div>
          <div>{{ reviewMsgOptionInfo.type == 'text' ? reviewMsgOptionInfo.text : reviewMsgOptionInfo.type == 'image' ? '[图片]' : '[文件]'}}</div>
        </div>
        <div class="iconfont icon-guanbi2" @click="isReview = false"></div>
      </div>
      <div class="ait-warp" v-if="showAitwarp">
        <div class="ait-list" @click="aitMember('所有人')">@所有人</div>
        <div class="ait-list d-flex" @click="aitMember(item.user.nick)" v-for="item in chatMemberListFilter"><img :src="item.user.avatar" alt="">{{ item.user.nick }}<div>{{ item.user.custom != undefined ? item.user.custom.member_type_text : '导师' }}</div></div>
      </div>
<!--      <div v-if="haveNewInfo" class="new-tips" @click="bottomScrollClick">2 条新消息<i class="el-icon-arrow-down"></i></div>-->
      <div class="case-chat-function">
        <div class="chat-left-function">
          <el-popover
              offset=30
              placement="bottom"
              trigger="manual"
              v-model="emojiVisible"
              width="274">
            <div class="emoji-warp">
              <div v-for="(value,key,index) in emoji"  class="iconemoji" @click="emojiIn(key)" :class="value">
                <img :src="require('@/assets/img/emoji/' + value)" alt="">
              </div>
<!--              <div v-for="item in emoji" :class="item.icon" class="iconemoji" @click="emojiIn(item.name)"></div>-->
            </div>
            <i slot="reference" class="iconfont icon-im-emoji" @click="emojiVisible = !emojiVisible"></i>
          </el-popover>
          <div class="file-send-item">
            <i class="iconfont icon-im-tupian"></i>
            <input id="msgImg" :multiple="false" accept="image/*" type="file" @change="handleImgChange">
          </div>
          <div class="file-send-item">
            <i class="iconfont icon-im-wenjian"></i>
            <input id="msgFile" type="file" :multiple="false" @change="handleFileChange">
          </div>
          <i v-if="member.member_type != 0" class="iconfont icon-baibaoxiang" @click="openBbx"></i>
        </div>
        <div class="chat-right-function">
          <i class="iconfont icon-im-liaotianjilu" @click="openHistory"></i>
          <i class="iconfont icon-im-qunchengyuan" @click="openTeamMember"></i>
        </div>
      </div>
      <el-input
          v-model="msg"
          :autosize="{ minRows: 4, maxRows: 4}"
          class="chat-in-msg" placeholder="请输入消息，按Enter键或点击发送按钮" type="textarea"
          @input="chatMsgInput"
          @keydown.native="keyDown"></el-input>
      <div class="chat-btn" >
        <div @click="sendMsg">发送</div>
        <el-popover
            offset=90
            placement="top"
            trigger="click"
            width="226">
          <div>
            <div :class="submitType === 1 ? 'enter-type-checked' : ''" class="enter-type" @click="submitType = 1"><i
                class="el-icon-check"></i>按Enter发送消息
            </div>
            <div :class="submitType === 2 ? 'enter-type-checked' : ''" class="enter-type" @click="submitType = 2"><i
                class="el-icon-check"></i>按Ctrl/CMD+Enter发送消息
            </div>
          </div>
          <i slot="reference" class="el-icon-caret-top"></i>
        </el-popover>

      </div>
    </div>
    <!--    右击显示-->
    <div v-if="msgOptionState" :style="{'left':msgOptionPosition[0] + 'px','top':msgOptionPosition[1] + 'px'}"
         class="msg-option">
      <div class="msg-option-item msg-option-line" @click="copyText" v-if="msgOptionInfo.type == 'text'">复制</div>
      <div class="msg-option-item" @click="resviewInfo">回复</div>
      <div class="msg-option-item msg-option-line" v-if="member.member_type != 0" @click="joinBbx">加入百宝箱</div>
      <div v-if="showReback" class="msg-option-item" @click="rebackMsg">撤回</div>
    </div>
    <el-dialog
        :visible.sync="showTalkHistoryDialog"
        custom-class="take-dialog grey-bg"
        title="聊天记录"
        width="834px">
      <div class="history-nav d-flex-center">
        <div :class="historyType == 1 ? 'on' : ''" @click="historyChange(1)">文本</div>
        <div :class="historyType == 2 ? 'on' : ''" @click="historyChange(2)">图片</div>
        <div :class="historyType == 3 ? 'on' : ''" @click="historyChange(3)">文件</div>
      </div>
      <template v-if="historyType == 1">
        <div class="d-flex-between" style="align-items: center">
          <div class="icon-input">
            <div class="iconfont icon-sousuo"></div>
            <Input :placeholder="'输入关键字进行搜索'" v-model="historyOption.keyword" @enter="getHistoryList('new')"/>
          </div>
          <div class="history-date-btn">
            <div class="iconfont icon-rili"></div>
            <el-date-picker
                v-model="historyOption.date"
                class="history-date-table"
                range-separator="至"
                type="daterange"
                @change="getHistoryList('new')">
            </el-date-picker>
          </div>
        </div>
        <div class="history-num-count">
          <span v-if="historyOption.date.length">
            {{new Date(historyOption.date[0]).toLocaleDateString()}}
            —
            {{ new Date(historyOption.date[1]).toLocaleDateString() }}
          </span>
          <div v-if="historyOption.date.length" class="iconfont icon-guanbi3" @click="clearSearchOption('date')"></div>
          <span v-if="historyOption.length && historyOption.keyword.trim() != ''">
            {{historyOption.length}}条与“{{ historyOption.keyword }}”有关的内容
          </span>
        </div>
        <div class="warp-max-height" @scroll="historyScroll">
          <div v-if="loadStatus == 'load'" class="load-info"><i class="el-icon-loading"></i>加载中</div>
          <div class="talk-history-warp">
            <template v-if="historyList.length">
              <div v-for="item in historyList"  class="talk-history-line">
                <img :src="avatarData[item.from]" alt="" class="talk-history-txt-img">
                <div>
                  <div class="talk-history-name d-flex-between">
                    <div>{{ item.fromNick }}</div>
                    <div>{{ new Date(item.time).toLocaleDateString() }}</div>
                  </div>
                  <div class="talk-history-cont" v-html="item.text"></div>
                </div>
                <div class="location iconfont icon-dingwei" @click="getChatLocation(item.time)"></div>
              </div>
            </template>
<!--            <div v-if="historyOver && historyList.length" class="msg-line">-->
<!--              <div class="msg-over">没有更多了</div>-->
<!--            </div>-->
            <Empty v-if="!historyList.length" :info="'暂无聊天记录'" :img-width="'200px'" />
          </div>
        </div>
      </template>
      <div v-if="historyType == 2" class="warp-max-height" @scroll="historyScroll"  style="flex-direction: column">
        <div v-if="loadStatus == 'load'" class="load-info"><i class="el-icon-loading"></i>加载中</div>
        <template v-for="(item,key) in historyImgList" v-if="historyImgList != {}">
          <div class="history-time">{{ key }}</div>
          <div class="history-img-warp">
            <div class="history-img-item"  v-for="subItem in item">
              <el-image
                  :initial-index="0"
                  :preview-src-list="[subItem.file.url]"
                  :src="subItem.file.url"
                  fit="cover">
              </el-image>
              <div class="location-img iconfont icon-dingwei" @click.stop="getChatLocation(subItem.time)"></div>
            </div>
          </div>
        </template>
        <Empty v-if="historyImgList == {}" :info="'暂无聊天记录'" :img-width="'200px'" />
      </div>
      <template v-if="historyType == 3">
        <div class="d-flex-between" style="align-items: center">
          <div class="icon-input">
            <div class="iconfont icon-sousuo"></div>
<!--            <input v-model="historyOption.keyword" type="text">-->
<!--            <div v-if="historyOption.keyword.trim().length" class="iconfont icon-guanbi3"-->
<!--                 @click="clearSearchOption('key')"></div>-->
            <Input :placeholder="''" v-model="historyOption.keyword" @enter="getHistoryList('new')"/>
          </div>
          <div class="history-date-btn">
            <div class="iconfont icon-rili"></div>
            <el-date-picker
                v-model="historyOption.date"
                class="history-date-table"
                range-separator="至"
                type="daterange"
                @change="getHistoryList('new')">
            </el-date-picker>
          </div>
        </div>
        <div class="history-num-count">
          <span v-if="historyOption.date.length">{{
              new Date(historyOption.date[0]).toLocaleDateString()
            }} — {{ new Date(historyOption.date[1]).toLocaleDateString() }}</span>
          <div v-if="historyOption.date.length" class="iconfont icon-guanbi3" @click="clearSearchOption('date')"></div>
          <span v-if="historyOption.length && historyOption.keyword.trim() != ''">{{
              historyOption.length
            }}条与“{{ historyOption.keyword }}”有关的内容</span>
        </div>
        <div class="warp-max-height" @scroll="historyScroll">
          <div v-if="loadStatus == 'load'" class="load-info"><i class="el-icon-loading"></i>加载中</div>
          <div class="talk-history-warp">
            <template v-if="historyList.length">
              <div v-for="item in historyList" @click="openUrl(item.file.url)" class="talk-history-line" target="_blank">
                <img v-if="'png,jpg,jpeg'.indexOf(item.file.ext) !== -1" alt=""
                     class="talk-history-file-img" src="@/assets/img/fileType/png.png">
                <img v-else-if="'xls,xlsx'.indexOf(item.file.ext) !== -1" alt=""
                     class="talk-history-file-img" src="@/assets/img/fileType/excel.png">
                <img v-else-if="'pdf'.indexOf(item.file.ext) !== -1" alt=""
                     class="talk-history-file-img" src="@/assets/img/fileType/pdf.png">
                <img v-else-if="'txt'.indexOf(item.file.ext) !== -1" alt=""
                     class="talk-history-file-img" src="@/assets/img/fileType/txt.png">
                <img v-else-if="'doc,docx'.indexOf(item.file.ext) !== -1" alt=""
                     class="talk-history-file-img" src="@/assets/img/fileType/word.png">
                <img v-else-if="'zip'.indexOf(item.file.ext) !== -1" alt=""
                     class="talk-history-file-img" src="@/assets/img/fileType/zip.png">
                <img v-else alt="" class="talk-history-file-img" src="@/assets/img/fileType/unknow.png">
                <div>
                  <div class="talk-history-name d-flex-between">
                    <div style="font-size: 14px;color: #333333">{{ item.file.name }}</div>
                    <div>{{ new Date(item.time).toLocaleDateString() }}</div>
                  </div>
                  <div class="talk-history-file d-flex-between">
                    <div>{{ item.fromNick }}</div>
                    <div>{{
                        item.file.size / 1048576 > 1 ? (item.file.size / 1048576).toFixed(2) + 'M' : (item.file.size / 1024).toFixed(0) + 'KB'
                      }}
                    </div>
                  </div>
                </div>
                <div class="location iconfont icon-dingwei" @click.stop="getChatLocation(item.time)"></div>
              </div>
            </template>
<!--            <div v-if="historyOver" class="msg-line">-->
<!--              <div class="msg-over">没有更多了</div>-->
<!--            </div>-->
            <Empty v-if="!historyList.length" :info="'暂无聊天记录'" :img-width="'200px'" />
          </div>
        </div>
      </template>
    </el-dialog>
    <el-dialog
        :visible.sync="showPersonDialog"
        custom-class="take-dialog"
        title="群聊成员"
        width="834px">
      <div class="icon-input" style="background: #F5F5F5">
        <div class="iconfont icon-sousuo"></div>
        <Input :placeholder="''" v-model="memberKeyWord" @enter="filterChatMember"/>
      </div>
      <div class="warp-max-height d-flex-warp">
        <div v-for="item in chatMemberListFilter" class="member-item member-item-long">
          <template v-if="item.user">
            <img :src="item.user.avatar"  :alt="item.user.custom != undefined ? item.user.custom.member_type_text : '导师' ">
            <div class="member-item-long-info">
              <div class="member-item-name">{{ item.user.nick }}</div>
              <div class="member-item-site">{{ item.user.custom != undefined ? item.user.custom.member_type_text : '导师' }}</div>
            </div>
          </template>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :visible.sync="showBabyDialog"
        custom-class="take-dialog"
        title="百宝箱"
        width="834px">
      <div class="baby-nav">
        <div :class="tab_type == 1? 'on' : ''" @click="tabTypeChange(1)">我的</div>
        <div :class="tab_type == 2? 'on' : ''" @click="tabTypeChange(2)">通用</div>
      </div>
      <div class="baby-warp">
        <div class="history-nav d-flex-center">
          <div :class="bbxType == 0 ? 'on' : ''" @click="bbxTypeChange(0)">文本</div>
          <div :class="bbxType == 1 ? 'on' : ''" @click="bbxTypeChange(1)">图片</div>
          <div :class="bbxType == 2 ? 'on' : ''" @click="bbxTypeChange(2)">文件</div>
        </div>
        <div class="icon-input">
          <div class="iconfont icon-sousuo"></div>
          <Input :placeholder="''" v-model="historyKeyWords" @enter="getBbxList"/>
        </div>
        <div v-if="bbxType == 0" class="baby-info-warp" style="flex-direction: column">
          <div v-if="loadStatus == 'load'" class="load-info"><i class="el-icon-loading"></i>加载中</div>
          <template v-for="item in bbxList">
            <el-popover
              placement="left-start"
              width="100"
              trigger="hover">
              <div class="send-box-btn"  @click="boxContentSend('text',item)">发送</div>
              <div class="del-box-btn" v-if="tab_type == 1"  @click="boxContentDel(item)">删除</div>
              <div class="baby-info" slot="reference" v-html="item.content"></div>
            </el-popover>
          </template>
          <Empty v-if="!bbxList.length && loadStatus != 'load'" :info="'暂无内容'" :img-width="'200px'" />
        </div>
        <div v-if="bbxType == 1" class="baby-info-warp">
          <div v-if="loadStatus == 'load'" class="load-info"><i class="el-icon-loading"></i>加载中</div>
          <template v-for="item in bbxList">
            <el-popover
              placement="left-start"
              width="100"
              trigger="hover">
              <div class="send-box-btn"  @click="boxContentSend('img',item)">发送</div>
              <div class="del-box-btn" v-if="tab_type == 1"  @click="boxContentDel(item)">删除</div>
              <el-image
                slot="reference"
                :preview-src-list="[item.target_url]"
                :src="item.target_url"
                style="width: 100px;height: 100px;margin: 10px">
              </el-image>
            </el-popover>
          </template>
          <Empty v-if="!bbxList.length && loadStatus != 'load'" :info="'暂无内容'" :img-width="'200px'" />
        </div>
        <div v-if="bbxType == 2" class="baby-info-warp"  style="flex-direction: column">
          <div v-if="loadStatus == 'load'" class="load-info"><i class="el-icon-loading"></i>加载中</div>
          <template v-for="item in bbxList">
            <el-popover
              placement="left-start"
              width="100"
              trigger="hover">
              <div class="send-box-btn" @click="boxContentSend('file',item)">发送</div>
              <div class="del-box-btn" v-if="tab_type == 1"  @click="boxContentDel(item)">删除</div>
              <a  slot="reference" :href="item.target_url" class="msg-cont-file"
                 target="_blank">
                <img v-if="'png,jpg,jpeg'.indexOf(item.file_type) !== -1" alt=""
                     class="msg-cont-file-img" src="@/assets/img/fileType/png.png">
                <img v-else-if="'xls,xlsx'.indexOf(item.file_type) !== -1" alt=""
                     class="msg-cont-file-img" src="@/assets/img/fileType/excel.png">
                <img v-else-if="'pdf'.indexOf(item.file_type) !== -1" alt=""
                     class="msg-cont-file-img" src="@/assets/img/fileType/pdf.png">
                <img v-else-if="'txt'.indexOf(item.file_type) !== -1" alt=""
                     class="msg-cont-file-img" src="@/assets/img/fileType/txt.png">
                <img v-else-if="'doc,docx'.indexOf(item.file_type) !== -1" alt=""
                     class="msg-cont-file-img" src="@/assets/img/fileType/word.png">
                <img v-else-if="'zip'.indexOf(item.file_type) !== -1" alt=""
                     class="msg-cont-file-img" src="@/assets/img/fileType/zip.png">
                <img v-else alt="" class="msg-cont-file-img" src="@/assets/img/fileType/unknow.png">
                <div>
                  <div class="msg-cont-file-name">{{ item.abstract_info ? item.abstract_info : '文件丢失' }}</div>
                  <div class="msg-cont-file-size">{{ item.file_size + 'B' }}
                  </div>
                </div>
              </a>
            </el-popover>
          </template>
          <Empty v-if="!bbxList.length && loadStatus != 'load'" :info="'暂无内容'" :img-width="'200px'" />
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :visible.sync="showCycleDialog"
        custom-class="take-dialog"
        title="全周期辅导咨询"
        width="354px">
      <div class="cycle-line1">全周期病例辅导，将由临床实战经验极其丰富的指导医师，为该病例提供详细治疗方案。</div>
      <div class="cycle-line2">
        <img src="@/assets/img/chat/left-line.png" alt="">
        <div>解锁即享以下权益</div>
        <img src="@/assets/img/chat/right-line.png" alt="">
      </div>
      <div class="cycle-info">
        <div><img src="@/assets/img/chat/gou.png" alt="">解除首诊卡咨询限制，至时长结束</div>
        <div><img src="@/assets/img/chat/gou.png" alt="">每月1次复诊辅导，直至病例结束</div>
        <div><img src="@/assets/img/chat/gou.png" alt="">每3个月1次会诊，直至病例结束</div>
        <div><img src="@/assets/img/chat/gou.png" alt="">协助您填写矫治器设计单，直至病例结束</div>
      </div>
      <div></div>
      <div></div>
      <div class="take-dialog-bottom">
        <div class="take-dialog-close" @click="showCycleDialog = false">暂不解锁</div>
        <div @click="luckChat" class="take-dialog-open">立即解锁</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import emoji from "@/utils/emoji";
import ChatMessage from "@/views/case_management/case_components/ChatMessage.vue";
import {DelayChat, GetBbxList, GetCaseInfo, GetConsultRecord, GetMeetingInfo, SaveBbx, ToFullConsult} from "@/http/api";
import {fileProcess} from "@/assets/js/imgHandle";
import {deleteById} from "@/http/box";


export default {
  name: "Chat",
  components: {ChatMessage},
  props: {
    group_id: {
      default: 0,
      type: Number
    },
    card_id:null,
    caseId:null,
    meeting_id:null,
  },
  data() {
    return {
      nim: null,
      initFinish: false,
      msg: '',
      emoji,
      caseDetailValue:{},
      chatList: [],
      isReview: false,
      msgOptionState: false,
      showReback:true,
      msgOptionPosition: [],
      msgOptionInfo: {},
      reviewMsgOptionInfo: {},
      submitType: 1,
      haveNewInfo: true,
      showTalkHistoryDialog: false,
      showPersonDialog: false,
      showBabyDialog: false,
      historyType: 1, //聊天记录类型
      historyOption: {
        date: [],
        keyword: '',
        length: 0
      },
      historyList: [],
      historyImgList: [],
      historyKeyWords: '',
      member: JSON.parse(localStorage.getItem('member')), //个人信息
      chatMemberList: [], //群聊成员
      chatMemberListFilter: [], //群聊成员
      bbxType: 0, //百宝箱类型
      tab_type: 1, //百宝箱我的：1，通用：2
      bbxList: [], //百宝箱数据列表
      loadStatus: '',
      scrollPosition: true,
      isTop: false,
      scrollHeight:0,
      windowHeight:0,
      scrollTop:0,
      avatarData:{},
      historyOver:false,
      showCycleDialog:false,
      meetingData:undefined,
      memberKeyWord:'',
      sendStatus:true,
      showAitwarp:false,
      emojiVisible:false
    }
  },
  mounted() {
    this.initCaseData()
  },
  beforeDestroy(){
     console.log('销毁之前执行')
     this.nim.destroy()
  },
  methods: {
    initSendStatus(type){
      if(type == 'time'){
        GetConsultRecord({case_card_id:this.card_id,add_consult:true}).then(res=>{
          let beginTime = new Date(res.data.begin_date).getTime()
          if( new Date().getTime() -  beginTime > 86400000) this.sendStatus = false
        })
      }else{
        let num = 0
        this.chatList.forEach(item=>{
          if(item.fromClientType != 'Server' && this.member.yunxin_accid == item.from) num ++
        })
        if(num > 3) this.sendStatus = false
      }
      console.log('sendStatus',this.sendStatus)
    },
    keyDown(e) {
      if(this.submitType == 1){
        if (!e.ctrlKey && !e.shiftKey && e.keyCode == 13) {
          e.cancelBubble = true;
          e.stopPropagation();
          e.preventDefault();
          this.sendMsg()
        }
      }else{
        if (e.ctrlKey && e.keyCode == 13) {
          e.cancelBubble = true;
          e.stopPropagation();
          e.preventDefault();
          this.sendMsg()
        }
      }
    },
    chatMsgInput(e){
      if(e.substring(e.length - 1) == '@') this.showAitwarp = true
      else this.showAitwarp = false
    },
    aitMember(name){
      this.msg = this.msg + name + ' '
      this.showAitwarp = false
    },
    initIM() {
      var _that = this
      console.log('初始化initIM')
      _that.nim = _that.NIM.getInstance({
        debug: false,
        appKey: '7f04e1c69a70c76abe78563ce9831a39',
        account: _that.member.yunxin_accid,
        token: _that.member.yunxin_token,
        autoMarkRead: true,
        syncSessionUnread: true,
        onmsg: _that.onMsg,
        onsyncdone: function () {
          console.log('wccccc')
          _that.initFinish = true
          _that.$emit('finish')

          // console.log('设置当前会话（如果是已经存在的会话记录，会将此会话未读数置为 0）');
          _that.nim.setCurrSession(`team-${_that.caseDetailValue.im_group_id}`);

          _that.getChatMember()
          _that.getMsg()
        }, // 同步完成
        onconnect:function (err) {
          console.log(err)
        },
        onsysmsg: this.onSysMsg
      });
    },
    sendMsg(type,data) {
      if(this.caseDetailValue.finished_status == 1){
        this.$message({
          type:'error',
          message:'该病例已结束咨询'
        })
        return false;
      }
      if(!this.sendStatus){
        this.showCycleDialog = true
        return false;
      }
      console.log('fas')
      var _that = this
      if (!this.msg.trim()) return
      //判断是否是转发消息
      if(this.isReview){
        let custom = {
          yxReplyMsg: {
            from: this.reviewMsgOptionInfo.from,
            idClient: this.reviewMsgOptionInfo.idClient,
            idServer: this.reviewMsgOptionInfo.idServer,
            scene: "team",
            time: this.reviewMsgOptionInfo.time,
            to: this.reviewMsgOptionInfo.to
          }
        }
        //判断是否是自己转发自己的，不是的话
        if(this.reviewMsgOptionInfo.from != this.member.yunxin_accid){
          custom.yxAitMsg={}
          custom.yxAitMsg[this.reviewMsgOptionInfo.from] = {
            accid:this.reviewMsgOptionInfo.from,
            text:this.reviewMsgOptionInfo.text ? this.reviewMsgOptionInfo.text : '[文件]'
          }
        }
        this.nim.sendText({
          scene: 'team',
          to: this.caseDetailValue.im_group_id,
          text: this.msg,
          custom :  JSON.stringify(custom),
          env: process.env.VUE_APP_YX_CHAOSONG_ENV,
          done: (error, msg) => {
            _that.msg = ''
            _that.chatList = _that.chatList.concat(msg)
            _that.bottomScrollClick()
            _that.isReview = false
            console.log('发送' + msg.scene + ' ' + msg.type + '消息' + (!error ? '成功' : '失败') + ', id=' + msg.idClient);
            console.log(msg);
          }
        });
      }else if(type == 'order'){
        this.nim.sendCustomMsg({
          scene: 'team',
          to: this.caseDetailValue.im_group_id,
          custom :  JSON.stringify(data),
          content: JSON.stringify({msg:''}),
          env: process.env.VUE_APP_YX_CHAOSONG_ENV,
          done: (error, msg) => {
            _that.msg = ''
            _that.chatList = _that.chatList.concat(msg)
            _that.bottomScrollClick()
            console.log(error)
            console.log('发送' + msg.scene + ' ' + msg.type + '消息' + (!error ? '成功' : '失败') + ', id=' + msg.idClient);
          }
        });
      }else{
        this.nim.sendText({
          scene: 'team',
          to: this.caseDetailValue.im_group_id,
          text: this.msg,
          env: process.env.VUE_APP_YX_CHAOSONG_ENV,
          done: (error, msg) => {
            _that.msg = ''
            _that.chatList = _that.chatList.concat(msg)
            _that.bottomScrollClick()
            console.log(error)
            console.log('发送' + msg.scene + ' ' + msg.type + '消息' + (!error ? '成功' : '失败') + ', id=' + msg.idClient);
          }
        });
      }
    },
    boxContentSend(type,cont){
      if(this.caseDetailValue.finished_status == 1){
        this.$message({
          type:'error',
          message:'该病例已结束咨询'
        })
        return false;
      }
      if(!this.sendStatus){
        this.showCycleDialog = true
        return false;
      }
      let _that = this
      if(type == 'text'){
        this.msg = cont.content
        this.sendMsg()
        this.showBabyDialog = false
      }else if(type == 'img'){
        fileProcess(cont.target_url,new Date().getTime() + '.png').then(fileList =>{
          this.nim.sendFile({
            scene: 'team',
            to: this.caseDetailValue.im_group_id,
            type: 'image',
            file: fileList,
            env: process.env.VUE_APP_YX_CHAOSONG_ENV,
            done: function (err, obj) {
              _that.showBabyDialog = false
              if (err) {
                console.log('发送失败', err)
                // 重发. 当上传文件失败时 obj 参数的 msg 附带消息体，其他情况的 obj 就是消息体。
                setTimeout(function () {
                  this.resendMessage(obj.msg ? obj.msg : obj, 'msgImg', 'image')
                }, 3000)
              } else {
                console.log('发送消息成功，消息为: ', obj)
                _that.chatList = _that.chatList.concat(obj)
                _that.bottomScrollClick()
              }
            }
          })
        })
      }else{
        console.log(cont)
        this.nim.sendFile({
          scene: 'team',
          to: this.caseDetailValue.im_group_id,
          type: 'file',
          file: {
            url:cont.target_url,
            name:cont.abstract_info,
            size:cont.file_size,
            ext:cont.file_type
          },
          env: process.env.VUE_APP_YX_CHAOSONG_ENV,
          done: function (err, obj) {
            _that.showBabyDialog = false
            if (err) {
              console.log('发送失败', err)
              // 重发. 当上传文件失败时 obj 参数的 msg 附带消息体，其他情况的 obj 就是消息体。
              setTimeout(function () {
                this.resendMessage(obj.msg ? obj.msg : obj, 'msgFile', 'file')
              }, 3000)
            } else {
              console.log('发送消息成功，消息为: ', obj)
              _that.chatList = _that.chatList.concat(obj)
              _that.bottomScrollClick()
            }
          }
        })
      }
    },
    boxContentDel(item){
      this.$confirm("确认要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return deleteById({ id: [item.id] });
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          } else {
            this.$message.error(res.message[0] ? res.message[0] : "删除失败");
          }
          this.getBbxList();
        })
    },
    handleImgChange(e) {
      if(this.caseDetailValue.finished_status == 1){
        this.$message({
          type:'error',
          message:'该病例已结束咨询'
        })
        return false;
      }
      if(!this.sendStatus){
        this.showCycleDialog = true
        return false;
      }
      if(!this.sendStatus){
        this.showCycleDialog = true
        return false;
      }
      var _that = this
      this.nim.sendFile({
        scene: 'team',
        to: this.caseDetailValue.im_group_id,
        type: 'image',
        fileInput: 'msgImg',
        env: process.env.VUE_APP_YX_CHAOSONG_ENV,
        done: function (err, obj) {
          if (err) {
            console.log('发送失败', err)
            // 重发. 当上传文件失败时 obj 参数的 msg 附带消息体，其他情况的 obj 就是消息体。
            setTimeout(function () {
              this.resendMessage(obj.msg ? obj.msg : obj, 'msgImg', 'image')
            }, 3000)
          } else {
            console.log('发送消息成功，消息为: ', obj)
            _that.chatList = _that.chatList.concat(obj)
            _that.bottomScrollClick()
          }
        }
      })
    },
    handleFileChange(e) {
      if(this.caseDetailValue.finished_status == 1){
        this.$message({
          type:'error',
          message:'该病例已结束咨询'
        })
        return false;
      }
      if(!this.sendStatus){
        this.showCycleDialog = true
        return false;
      }
      var _that = this
      this.nim.sendFile({
        scene: 'team',
        to: this.caseDetailValue.im_group_id,
        type: 'file',
        fileInput: 'msgFile',
        env: process.env.VUE_APP_YX_CHAOSONG_ENV,
        done: function (err, obj) {
          if (err) {
            console.log('发送失败', err)
            // 重发. 当上传文件失败时 obj 参数的 msg 附带消息体，其他情况的 obj 就是消息体。
            setTimeout(function () {
              this.resendMessage(obj.msg ? obj.msg : obj, 'msgFile', 'file')
            }, 3000)
          } else {
            console.log('发送消息成功，消息为: ', obj)
            _that.chatList = _that.chatList.concat(obj)
            _that.bottomScrollClick()
          }
        }
      })
    },
    resendMessage(oldMessage, domId, fileType) {
      this.nim.sendFile(Object.assign(oldMessage, {
        scene: 'team',
        to: this.caseDetailValue.im_group_id,
        type: fileType,
        fileInput: domId,
        env: process.env.VUE_APP_YX_CHAOSONG_ENV,
        resend: true, // 注意这个 resend 标记为 true，才能固定使用 oldMessage 里的 idClient
        done: function (err, obj) {
          if (err) {
            console.log('发送失败', err)
          } else {
            console.log('发送消息成功，消息为: ', obj)
          }
        }
      }))
    },
    chatMsgScroll(e) {
      this.scrollTop = e.target.scrollTop
      this.windowHeight = e.target.clientHeight
      this.scrollHeight = e.target.scrollHeight
      if (this.scrollTop + this.windowHeight >= this.scrollHeight - 20 && this.scrollPosition ) {
        // 当前滚动条已经触底
        this.getMsg('bottom')
        this.scrollPosition = false
      } else if (this.scrollTop == 0 && this.scrollPosition && !this.isTop) {
        this.scrollPosition = false
        //上一页
        this.getMsg('last')
      }
    },
    getChatLocation(time){
      this.showTalkHistoryDialog = false
      this.getMsg('location',time)
    },
    getMsg(type,time) {
      let timeOption = {}
      if (type == 'last') timeOption = {endTime: this.chatList[0].time}
      else if (type == 'location') {
        timeOption = {beginTime : time}
        this.isTop = false
      //  到最后一条，且不是没有的状态
      }else if(type == 'bottom' && this.chatList.length){
        timeOption = {beginTime : this.chatList[this.chatList.length - 1].time + 1}
        this.isTop = false
      }else{
        timeOption = {endTime: new Date().getTime()}
        this.isTop = false
      }
      if( this.isTop ) return false
      this.nim.getHistoryMsgs({
        ...timeOption,
        asc: type == 'location' || type == 'bottom' ? false : true,
        reverse:type == 'location' || type == 'bottom' ? true : false,
        limit: 30,
        scene: 'team',
        to: this.caseDetailValue.im_group_id,
        done: (error, msg) => {
          console.log('ddddddd',type)
          console.log(msg.msgs)


          if (msg.msgs.length) {
            if (type == 'last') {
              this.chatList = msg.msgs.concat(this.chatList)
              this.$nextTick(()=>{
                let scrollEl = this.$refs.mianscroll;
                if( scrollEl.scrollHeight != this.scrollHeight){
                  scrollEl.scrollTo(0 ,scrollEl.scrollHeight - this.scrollHeight);
                }
              })
            } else if(type == 'location'){
              this.chatList = msg.msgs
              this.$nextTick(()=>{
                let scrollEl = this.$refs.mianscroll;
                scrollEl.scrollTo(0 ,4);
                this.getMsg('last')
              })
            }else if(type == 'bottom'){
              this.chatList = this.chatList.concat(msg.msgs)
            }else {
              this.chatList = msg.msgs
              this.bottomScrollClick()
              if(this.member.member_type == 0 && this.caseDetailValue.be_full_consult != 1) this.initSendStatus('num')
            }
          } else if(type == 'last'){
            this.isTop = true
          }
          console.log(this.chatList)
          //恢复可以更新数据状态
          setTimeout(() => {
            this.scrollPosition = true
          }, 500)
        }
      })
    },
    historyScroll(e){
      var scrollTop = e.target.scrollTop
      var windowHeight = e.target.clientHeight
      var scrollHeight = e.target.scrollHeight
      if (scrollTop + windowHeight >= scrollHeight - 20) {
        // 当前滚动条已经触底
        this.getHistoryList('more')
      }
    },
    openBbx() {
      this.getBbxList()
      this.historyKeyWords = ''
      this.showBabyDialog = true
    },
    getBbxList() {
      this.bbxList = []
      this.loadStatus = 'load'
      GetBbxList({
        tab_type: this.tab_type,
        message_type: this.bbxType,
        keyWords: this.historyKeyWords
      }).then(res => {
        this.loadStatus = ''
        this.bbxList = res.data.data
        if (this.bbxType == 0 && this.historyKeyWords.trim() != '') {
          res.data.data.forEach((item, index) => {
            this.bbxList[index] = item
            this.bbxList[index].content = item.content.replaceAll(this.historyKeyWords, '<span style="color: #FED400">' + this.historyKeyWords + '</span>')
            console.log(this.bbxList[index].content)
            console.log(this.bbxList)
          })
        }
      })
    },
    joinBbx() {
      this.msgOptionState = false
      console.log(this.msgOptionInfo)
      let option = {}
      if (this.msgOptionInfo.type == 'text') {
        option = {
          message_type: 0,
          content: this.msgOptionInfo.text
        }
      } else if (this.msgOptionInfo.type == 'image') {
        option = {
          message_type: 1,
          target_url: this.msgOptionInfo.file.url
        }
      } else if (this.msgOptionInfo.type == 'file') {
        option = {
          message_type: 2,
          abstract_info: this.msgOptionInfo.file.name,
          file_type: this.msgOptionInfo.file.ext,
          // file_size: this.msgOptionInfo.file.size / 1048576,
          file_size: this.msgOptionInfo.file.size,
          thumbnail_url: '',
          target_url: this.msgOptionInfo.file.url
        }
      } else {
        this.$message({
          type: 'warning',
          message: '暂不支持加入此类型'
        })
        return false
      }
      SaveBbx(option).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '加入成功'
          })
        }
      })
    },
    openTeamMember() {
      this.memberKeyWord = ''
      this.getChatMember()
      this.showPersonDialog = true
    },
    filterChatMember(type){
      if(type == 'clear') this.memberKeyWord = ''
      this.chatMemberListFilter = this.chatMemberList.filter((item) => {
        return  item.user.nick.indexOf(this.memberKeyWord) != -1
      })
    },
    getChatMember() {
      this.nim.getTeamMembers({
        teamId: this.caseDetailValue.im_group_id,
        done: (error, msg) => {
          this.chatMemberList = msg.members
          this.chatMemberListFilter = msg.members
          for (let i = 0; i < msg.members.length; i++) {
            this.nim.getUser({
              account: msg.members[i].account,
              done: (error, data) => {
                this.$set(this.chatMemberList[i], 'user', data)
                this.$set(this.chatMemberListFilter[i], 'user', data)
                if(this.chatMemberList[i].user.custom != undefined){
                  this.chatMemberList[i].user.custom = data.custom
                  this.chatMemberListFilter[i].user.custom = data.custom
                }
                if(!this.avatarData[msg.members[i].account]){
                  this.avatarData[msg.members[i].account] = data.avatar
                }
              }
            })
          }
        }
      })
    },
    onMsg(msg) {
      if(this.caseDetailValue.im_group_id == msg.to){
        console.log('消息监听', msg)
        this.chatList.push(msg)
        this.bottomScrollClick()
      }
    },
    onSysMsg(e) {
      console.log('系统消息监听')
      console.log(e)
      if (e.type == "deleteMsg") {
        this.chatList.find((item, index) => {
          if (item.idClient == e.msg.idClient) {
            this.$refs.chatMessage[index].msgChange('revoke')
          }
        })
      }else{
        if(this.scrollTop + this.windowHeight < this.scrollHeight - 40)  this.haveNewInfo = true
      }
    },
    bottomScrollClick() {
      let _that = this
      if(this.member.member_type == 0 && this.caseDetailValue.be_full_consult != 1) this.initSendStatus('num')
      setTimeout(()=>{
        this.$nextTick(() => {
          let scrollEl = this.$refs.mianscroll;
          console.log(scrollEl.scrollHeight)
          scrollEl.scrollTo({top: scrollEl.scrollHeight});
          _that.haveNewInfo = false
        });
      },500)
    },
    showMsgOption(addr, info) {
      this.msgOptionInfo = info
      this.msgOptionState = !this.msgOptionState
      this.msgOptionPosition = addr

      //判断信息是否是自己发送 //判断发送时间是否超过两分钟
      if(this.member.yunxin_accid != info.from)this.showReback = false
      else if((new Date().getTime() - info.time) > 120000) this.showReback = false
      else this.showReback = true
    },
    chatRightClick(e) {
      e.preventDefault()
    },
    emojiIn(name) {
      this.msg = this.msg + name
      this.emojiVisible = false
    },
    openHistory() {
      this.getHistoryList('new')
      //打开聊天记录弹窗时类型和时间都初始化
      this.historyOption.date = []
      this.historyType = 1
      this.clearSearchOption()
      this.showTalkHistoryDialog = true
    },
    clearSearchOption(type) {
      if (type == 'date') {
        this.historyOption.date = []
      } else {
        this.historyOption.keyword = ''
        this.historyOption.length = 0
      }
      this.getHistoryList('new')
    },
    historyChange(i) {
      this.historyType = i
      this.getHistoryList('new')
    },
    getHistoryList(type) {
      console.log(type)
      //刷新数据
      if(type == 'new'){
        this.historyList = []
        this.historyOver = false
      }
      //到底了，没有更多了
      if(this.historyOver) return false
      //更新加载状态
      this.loadStatus = 'load'
      //设置查找参数
      let obj = {
        desc: true,
        limit: 30,
        types: this.historyType == 1 ? ['text'] : this.historyType == 2 ? 'image' : 'file',
        sessionId: 'team-' + this.caseDetailValue.im_group_id,
      }
      if (this.historyOption.keyword.trim() != '') obj.keyword = this.historyOption.keyword

      if(type == 'more'){
        obj.end = this.historyList[this.historyList.length - 1].time
      }else if (this.historyOption.date.length) {
        obj.start = new Date(this.historyOption.date[0]).getTime()
        obj.end = new Date(this.historyOption.date[1]).getTime() + 86399000
      }
      this.nim.getLocalMsgs({
        ...obj,
        done: (err, data) => {
          this.loadStatus = ''
          if (err) {
            this.$message({
              type: 'error',
              message: '获取失败，请刷新页面'
            })
            return false
          }
          if(data.msgs.length){
            if(type == 'new') this.historyList = data.msgs
            else this.historyList = this.historyList.concat(data.msgs)

          }else{
            this.historyOver = true
          }
          if(this.historyType == 2){
            this.historyImgList = this.historyList.reduce((a,b)=>{
              let n = new Date(b.time).toLocaleDateString()
              if(a[n]){
                a[n].push(b)
              }else{
                a[n] = [b]
              }
              return a;
            },{})
            console.log(this.historyImgList)
          }
          if (data.msgs.length && this.historyOption.keyword.trim() != '') this.historyOption.length = data.msgs.length
          else this.historyOption.length = 0

          if (this.historyType == 1 && this.historyOption.keyword.trim() != '') {
            for (let i = 0; i < data.msgs.length; i++) {
              this.historyList[i].text = data.msgs[i].text.replaceAll(this.historyOption.keyword, '<span>' + this.historyOption.keyword + '</span>')
            }
          }
        }
      })
    },
    bbxTypeChange(i) {
      this.bbxType = i
      this.getBbxList()
    },
    tabTypeChange(i) {
      this.tab_type = i
      this.getBbxList()
    },
    copyText(){
      this.msgOptionState = false
      this.$copyText(this.msgOptionInfo.text).then(()=>{
        this.$message({
          type:'success',
          message:'复制成功'
        })
      }).catch(()=>{
        this.$message({
          type:'success',
          message:'复制失败'
        })
      })
    },
    resviewInfo() {
      this.isReview = true
      this.msgOptionState = false
      this.reviewMsgOptionInfo = this.msgOptionInfo
    },
    rebackMsg() {
      this.$confirm('确定撤回此条消息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delete this.msgOptionInfo.avatar
        this.msgOptionInfo.idServer = this.msgOptionInfo.idServer.replaceAll(',', '')
        this.nim.recallMsg({
          msg: this.msgOptionInfo,
          done: (err, data) => {
            this.msgOptionState = false
            if (err) {
              if (err.code === 508) {
                this.$message({
                  type: 'error',
                  message: '发送时间超过2分钟的消息，不能被撤回!'
                });
              } else {
                this.$message({
                  type: 'error',
                  message: '撤回失败!'
                });
              }
            } else {
              this.chatList.find((item, index) => {
                if (item.idClient == data.msg.idClient) {
                  this.$refs.chatMessage[index].msgChange('revoke')
                }
              })
            }

          }
        })
      })
    },
    openUrl(url){
      window.open(url, '_blank')
    },
    reFreshMeetingData(){
      GetMeetingInfo({id:this.meeting_id}).then(res2=>{
        this.meetingData = res2.data
        this.$emit('meetingData', res2.data)
      })
    },
    initCaseData(){
      GetCaseInfo({id: this.caseId}).then(res => {
        this.caseDetailValue = res.data
        if(this.meeting_id != undefined){
          GetMeetingInfo({id:this.meeting_id}).then(res2=>{
            this.meetingData = res2.data
            this.$emit('meetingData', res2.data)
            this.caseDetailValue.im_group_id = res2.data.yunxin_group_id
            this.initIM()
          })
        }else{
          this.initIM()
        }
        if(this.member.member_type == 0 && res.data.be_full_consult != 1) this.initSendStatus('time')
        this.$store.commit('caseDetailValueChange',this.caseDetailValue)
      })
    },
    luckChat(){
      this.showCycleDialog = false
      if(this.member.member_type == 1){
        DelayChat({case_card_id:this.card_id}).then(res=>{
            if(res.code == 200){
              this.$message({
                type:'success',
                message:'延长成功'
              })
              this.initCaseData()
            }else{
              this.$message({
                type:'error',
                message:res.message[0]
              })
            }
        })
      }else{
        ToFullConsult({patient_id:this.caseDetailValue.id,from:'info'}).then(res=>{
          if(res.code == 200){
            this.$message({
              type:'success',
              message:'解锁成功'
            })
            this.initCaseData()
          }
        })
      }
    }
  }
}
</script>

<style scoped src="../../../assets/css/case.css"></style>

<style scoped src="../../../assets/css/chat.css"></style>

<style>
.grey-bg {
  background: #F4F4F4;
  padding-bottom: 0;
}
.history-date-btn {
  position: relative;
  overflow: hidden;
}

.history-date-btn .icon-rili {
  cursor: pointer;
  padding-left: 15px;
  color: #333333;
  font-size: 20px;
  background: #F4F4F4;
  pointer-events: none;
  position: relative;
  z-index: 2;
}

.history-date-table {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  cursor: pointer;
}
</style>
